<div class="table-wrapper">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <qai-loading [size]="'medium'"></qai-loading>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && tableData.length === 0" class="empty-container">
    <p>No simulations found</p>
  </div>

  <!-- Data Loaded State -->
  <qai-table
    *ngIf="!isLoading && tableData.length > 0"
    [headers]="headers"
    [data]="tableData"
    [striped]="false"
    [isTooltipLoading]="isTooltipLoading"
    (tooltipDataRequested)="onTooltipDataRequested($event)"
    [initialSortColumn]="initialSortColumn"
    [initialSortDirection]="initialSortDirection"
  ></qai-table>
</div>
